const state_config = {
    url: '/inapp_offer_popups',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: 'Inapp Offer Popups',
        role: 'offers',
    },
};
export default state_config;
